/*
 * Application Insights JavaScript SDK - Core, 3.3.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
"use strict";
export var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map